<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import CaptainEmptyState from './CaptainEmptyState.vue';

const emit = defineEmits(['click']);

const { t } = useI18n();

const STEPS = [
  ['WRITE', 'i-lucide-pencil'],
  ['DOCUMENTS', 'i-lucide-file-text'],
  ['SUGGESTIONS', 'i-lucide-lightbulb'],
];

const steps = computed(() =>
  STEPS.map(([key, icon]) => ({
    icon,
    title: t(`CAPTAIN.RESPONSES.EMPTY_STATE.STEPS.${key}.TITLE`),
    description: t(`CAPTAIN.RESPONSES.EMPTY_STATE.STEPS.${key}.DESCRIPTION`),
  }))
);
</script>

<template>
  <CaptainEmptyState
    icon="i-lucide-message-circle-question"
    :title="t('CAPTAIN.RESPONSES.EMPTY_STATE.TITLE')"
    :subtitle="t('CAPTAIN.RESPONSES.EMPTY_STATE.SUBTITLE')"
    :steps="steps"
  >
    <template #actions>
      <Button
        :label="t('CAPTAIN.RESPONSES.ADD_NEW')"
        icon="i-lucide-plus"
        @click="emit('click')"
      />
    </template>
  </CaptainEmptyState>
</template>
